/**
 * Renders mobile menu social icons
 */
import * as React from 'react';

import { SocialGroup } from './styles';

/**
 * Renders social media icons
 *
 * @param props - Render props
 */
function Social(props: SocialMediaProps) {
  const { children } = props;

  return <SocialGroup>{children}</SocialGroup>;
}
interface SocialMediaProps {
  children: React.ReactNode;
}

export { Social };
